import { render } from "./Conteudo.vue?vue&type=template&id=7aee7e0b&scoped=true"
import script from "./Conteudo.vue?vue&type=script&lang=js"
export * from "./Conteudo.vue?vue&type=script&lang=js"

import "./Conteudo.vue?vue&type=style&index=0&id=7aee7e0b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\WS-CI002090\\workspace\\informativo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aee7e0b"]])

export default __exports__